import { render, staticRenderFns } from "./formBasicInfo.vue?vue&type=template&id=5fc33bb8&scoped=true"
import script from "./formBasicInfo.vue?vue&type=script&lang=js"
export * from "./formBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc33bb8",
  null
  
)

export default component.exports